import { useFormik } from 'formik';
import { useEffect } from 'react';
import { PqrClosing } from '../../../../../../../shared/types/modules/pqr';
import { useGetNameOrValue } from '../../../../../../../shared/utils/useGetNameOrValue';

export const usePqrComplianceTerms = (closing?: PqrClosing) => {
    const formik = useFormik({
        initialValues: {
            complianceTerms: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            complianceTerms: useGetNameOrValue(closing?.complianceTerms || ''),
        });
    }, [closing]);

    return {
        formik,
    };
};
